











import icoLookup from '@/utilities/ico-lookup'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { pickBy } from 'lodash-es'
import analytics from '@/analytics'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({})
export default class PrototypesList extends Vue {
  @Prop({ required: true }) prototypes!:any
  @Prop({ default: '' }) classes!:string
  @Prop({ default: false }) drop:any

  window: Window = window

  get visibleProtoypes ():any {
    return pickBy(this.prototypes, (value:any, key:any) => {
      return !!value.url // excludes items like text assets
    })
  }

  getImg (prototype:any):any {
    const icoLookupMap:any = icoLookup
    return icoLookupMap[prototype.asset_type] || prototype.url
  }

  prototypeClicked () {
    let eventName = 'Shared Report View Asset - '
    const trackedProperties:any = {}

    if (this.drop) {
      eventName += 'Test Uploads'
      trackedProperties.testId = this.drop.id
      trackedProperties.testType = this.drop.payload.testType
    } else {
      eventName += 'Uploads for entire Report'
    }

    analytics.track(eventName, trackedProperties)
  }
}
